/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-08-21 14:23:28
 * @LastEditors: WangYuhan
 */
// 运费支付方式
export const payTypeList = [
  { label: '司机', value: '1' },
  { label: '经纪人', value: '2' },
];
// 是/否
export const whethers = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];
// 结算单类型
export const waybillPayStatus = [
  { label: '待支付', value: 1 },
  { label: '部分支付', value: 2 },
  { label: '已支付', value: 3 },
];
// 结算单类型
export const settlementTypes = [
  { label: '预付运费', value: 'PAYADVANCE' },
  { label: '到付运费', value: 'PAYARRIVE' },
  { label: '回单押金', value: 'PAYBACK' },
];

// 司机类型
export const driverTypes = [
  { label: '外调司机', value: 'transfer' },
  { label: '自有司机', value: 'own' },
];

// 变动类型
export const alterationTypes = [
  { label: '运单分油', value: 'ACCEPT_TASK' },
  { label: '司机领油', value: 'WITHDRAW' },
  { label: '油款更新', value: 'OIL_CHANGE' },
  { label: '运单删除', value: 'OIL_WAYBILL_DEL' },
];

// 变动类型多一点
export const alterationMoreTypes = [
  { label: '运单分油', value: 'APPLY' },
  { label: '加油消费', value: 'OIL_USE_SUCCESS' },
  { label: '油款回收', value: 'OIL_RECYCLE' },
  { label: '司机领油', value: 'WITHDRAW' },
  { label: '交易撤销', value: 'OIL_USE_CANCEL' },
];

// 变动类型
export const tranType = [
  { label: '牛运宝储值', value: 'OIL_STORED_VALUE' },
  { label: '加油消费', value: 'OIL_USE_SUCCESS' },
  { label: '协商分油', value: 'OIL_WAYBILL_STORED_VALUE' },
  { label: '交易撤销', value: 'TRANSACTION_CANCELLATION' },
];

// 司机类型
export const stateTypes = [
  { label: '交易成功', value: '2' },
  { label: '交易撤销', value: '4' },
];
